import { render, staticRenderFns } from "./orderCancelPromptModal.vue?vue&type=template&id=c946eb54&scoped=true"
import script from "./orderCancelPromptModal.vue?vue&type=script&lang=js"
export * from "./orderCancelPromptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c946eb54",
  null
  
)

export default component.exports